import { sparkToast } from '@spark';

export const INVALID_JSON_SCHEMA_TOAST_TITLE = 'Invalid JSON schema';
export const MODEL_CONFIGURATION_STEP_LABEL = 'Model Configuration';

/**
 * Detailed error toast with a blue link that takes the user to Model
 * Configuration to fix an enabled JSON schema field.
 */
export function showInvalidJsonSchemaToast({ onGoToModelConfiguration } = {}) {
    const goToModelConfiguration = () => {
        onGoToModelConfiguration?.();
    };

    sparkToast.error(INVALID_JSON_SCHEMA_TOAST_TITLE, {
        detailed: true,
        duration: 10000,
        content: (
            <>
                The JSON schema is invalid. Fix it in the{' '}
                <span
                    className="spark-toast-link"
                    role="button"
                    tabIndex={0}
                    onClick={goToModelConfiguration}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            goToModelConfiguration();
                        }
                    }}
                >
                    {MODEL_CONFIGURATION_STEP_LABEL}
                </span>
                {' '}step before continuing.
            </>
        ),
    });
}
